function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
import Cookie from "js-cookie";
import { v4 as uuidv4 } from "uuid";
import axios from "axios";
import axiosRetry from 'axios-retry';
function getDeviceToken() {
  var deviceToken = Cookie.get("device_token");
  if (!deviceToken) {
    deviceToken = uuidv4().split("-").join("");
    Cookie.set("device_token", deviceToken, {
      expires: 365,
      path: "/",
      domain: ".mlb.com"
    });
  }
  return deviceToken;
}
function authorizeToken(_x, _x2) {
  return _authorizeToken.apply(this, arguments);
}
function _authorizeToken() {
  _authorizeToken = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(oktaClient, response) {
    var stateToken, tokenResponse;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            oktaClient.tokenManager.clear();
            stateToken = window.mlbOkta.generateStateToken();
            _context.next = 5;
            return oktaClient.token.getWithoutPrompt({
              sessionToken: response.data.sessionToken,
              state: stateToken
            });
          case 5:
            tokenResponse = _context.sent;
            window.mlbOkta.setTokens(tokenResponse.tokens);
            return _context.abrupt("return", true);
          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](0);
            console.error("authClientError", _context.t0);
          case 13:
            return _context.abrupt("return", false);
          case 14:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 10]]);
  }));
  return _authorizeToken.apply(this, arguments);
}
function mlbOktaLogin(email, password) {
  var config = window.mlbOkta.getAuthConfig();
  var deviceToken = getDeviceToken();
  var oktaUrl = "".concat(config.okta, "/api/v1/authn");
  var oktaData = {
    username: email,
    password: password,
    options: {
      multiOptionalFactorEnroll: false,
      warnBeforePasswordExpired: true
    },
    context: {
      deviceToken: deviceToken
    }
  };
  axiosRetry(axios, {
    retries: 5,
    retryDelay: function retryDelay(retryCount) {
      return retryCount * 500; // first retry at 500ms, final retry around 7s
    },

    retryCondition: function retryCondition(error) {
      return error.response.status === 401 || error.response.status === 404;
    }
  });
  return axios({
    method: "POST",
    url: oktaUrl,
    data: oktaData
  }).then(function (response) {
    return _objectSpread(_objectSpread({}, response), {}, {
      type: "okta"
    });
  });
}
function login(_x3, _x4) {
  return _login.apply(this, arguments);
}
function _login() {
  _login = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(email, password) {
    var loginResponse;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return mlbOktaLogin(email, password);
          case 2:
            loginResponse = _context2.sent;
            return _context2.abrupt("return", {
              mlbOktaLogin: loginResponse
            });
          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _login.apply(this, arguments);
}
export { login, authorizeToken };